import {AnyAction, createReducer} from '@reduxjs/toolkit'
import {SEND_RSVP_OLD, sendRsvp} from '../actions/rsvp'

export const guest = createReducer({}, builder => {
  builder
    .addCase(SEND_RSVP_OLD.SUCCESS, (_, action: AnyAction) => {
      return action.payload.rsvp
    })
    .addCase(sendRsvp.fulfilled, (_, action) => {
      return action.payload.rsvp
    })
})
